import { Bedarf } from '../../types/bedarf';
import { useBedarfActions, BedarfActionModals } from './actions';

interface BedarfStatusActionButtonsProps {
  bedarf: Bedarf;
  onActionComplete?: () => void;
}

export function BedarfStatusActionButtons({ bedarf, onActionComplete }: BedarfStatusActionButtonsProps) {
  const {
    primaryActions,
    isLoading,
    loadingAction,
    handleAction,
    modals,
  } = useBedarfActions({
    bedarf,
    onActionComplete,
    includeSecondaryActions: false,
    includeDangerActions: false,
  });

  if (primaryActions.length === 0) {
    return null;
  }

  return (
    <>
      <div className="mt-4 flex items-center flex-wrap gap-2">
        {primaryActions.map((actionConfig) => {
          const IconComponent = actionConfig.icon;
          return (
            <button
              key={actionConfig.key}
              onClick={() => handleAction(actionConfig)}
              disabled={isLoading}
              title={actionConfig.tooltip}
              className={`
                inline-flex items-center px-3 py-1.5 border rounded-md text-sm font-medium
                transition-colors duration-150 ease-in-out
                disabled:opacity-50 disabled:cursor-not-allowed
                ${actionConfig.color} ${actionConfig.hoverColor}
              `}
            >
              <IconComponent />
              <span className="ml-1.5">
                {loadingAction === actionConfig.key ? actionConfig.loadingLabel : actionConfig.label}
              </span>
            </button>
          );
        })}
      </div>

      <BedarfActionModals
        bedarf={bedarf}
        modals={modals}
        onModalComplete={onActionComplete}
      />
    </>
  );
}
